import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18331c02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=18331c02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18331c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18331c02')) {
      api.createRecord('18331c02', component.options)
    } else {
      api.reload('18331c02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18331c02&scoped=true", function () {
      api.rerender('18331c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/syncGoodsLog/index.vue"
export default component.exports